import { html, LitElement } from 'lit-element';
import { CloseButtonText, Button } from '../common/Button.js';
import { RationaleModal } from './RationaleModal.js';
import { RationaleModalMultipleChoice } from './RationaleModalMultipleChoice.js';
import { ViewDetailsModalECR } from './ViewDetailsModalECR.js';
import { ViewDetailsModalMathInline } from './ViewDetailsModalMathInline.js';
import { ViewDetailsModalMultipleChoice } from './ViewDetailsModalMultipleChoice.js';
import { ViewDetailsModalMultiItem } from './ViewDetailsModalMultiItem.js';
import { ResponseModalECR } from './ResponseModalECR.js';
import { ResponseModalMultipleChoice } from './ResponseModalMultipleChoice.js';
import { ResponseModalMathInline } from './ResponseModalMathInline.js';
import { ResponseModalMultiItem } from './ResponseModalMultiItem.js';
import { defineElement } from '../classifier/utils.js';
import { Markup } from '../common/MarkupWrapper.js';
import { SlotsWrapper } from '../common/SlotsWrapper.js';

const modelTypes = {
  'rationale-modal': RationaleModal,
  'rationale-modal-multiple-choice': RationaleModalMultipleChoice,
  'response-modal-ecr': ResponseModalECR,
  'response-modal-math-inline': ResponseModalMathInline,
  'response-modal-multiple-choice': ResponseModalMultipleChoice,
  'response-modal-multi-item': ResponseModalMultiItem,
  'view-details-modal-ecr': ViewDetailsModalECR,
  'view-details-modal-math-inline': ViewDetailsModalMathInline,
  'view-details-modal-multiple-choice': ViewDetailsModalMultipleChoice,
  'view-details-modal-multi-item': ViewDetailsModalMultiItem,
};

// TODO improve this

/**
 * @element ct-modal
 * @prop {Object} modalData - { modalType, modalContent, modalTitle }
 */
export class CTModal extends LitElement {
  static get properties() {
    return {
      modalData: {
        type: Object,
      },
    };
  }

  constructor() {
    super();

    defineElement('ct-modal-button', Button);
    defineElement('markup-wrapper', Markup);
    defineElement('slots-wrapper', SlotsWrapper);
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    const { modalType } = this.modalData || {};

    if (modalType && !customElements.get(modalType)) {
      customElements.define(modalType, modelTypes[modalType]);
    }
  }

  static closeModal() {
    window.dispatchEvent(new CustomEvent('classroom-tool-live-close-modal'));
  }

  render() {
    const { modalContent, modalTitle } = this.modalData || {};

    return html` <div class="modal-content">
      <div class="scrollable">
        <div class="modal-response-header">
          ${modalTitle}
          <button class="modal-close-x" @click=${CTModal.closeModal}>X</button>
        </div>

        ${modalContent}
      </div>

      <div class="modal-close-button-container">
        <ct-modal-button
          .text=${CloseButtonText}
          .onClick=${CTModal.closeModal}
        ></ct-modal-button>
      </div>
    </div>`;
  }
}

export default CTModal;
